import { OverlayRef } from '@angular/cdk/overlay';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type CmsHotspotsState = {
    overlayRef: OverlayRef | undefined;
};

const initialState: CmsHotspotsState = {
    overlayRef: undefined,
};

export const CmsHotspotsStore = signalStore(
    withState(initialState),
    withMethods(store => ({
        updateOverlayRef(value?: OverlayRef): void {
            patchState(store, (state: CmsHotspotsState) => ({ ...state, overlayRef: value }));
        },
    }))
);